<template>
    <div>
        <div v-if="windowWidth > 1279" class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>
            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box">
                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <label class="done">Registration</label>
                                    <label class="done">Payment</label>
                                    <label class="done" href="#">Visa Form</label>
                                    <label class="active" href="#">Documents</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-1">

                        </div>
                        <div class="col-8">
                            <div class="document top124">
                                <div class="document-block">
                                    <div class="left">
                                        <h3>Your photo</h3>
                                        <p>Each applicant must submit a color photograph, without corners, with a full face;</p>
                                        <p>The photo must have been taken within the last six months;</p>
                                        <p class="bt-24">The photo must be in color, on a white background, without frames and retouching</p>
                                        <a class="app-btn-proceed" href="/#/req_photo">read more</a>
                                    </div>
                                    <div id="dropPic" class="portrait">
                                        <img id="img1" class="img-thumbnail" :src="userAvatar" />
                                        <div class="dz-default dz-message">
                                            <button id="pick-avatar" class="dz-button" type="button">Click to upload photo</button>
                                        </div>
                                    </div>
                                    <div>
                                        <img v-if="userAvatar" :src="userAvatar">

                                        <avatar-cropper trigger="#pick-avatar"
                                                        :labels="cropLabels"
                                                        :upload-url="uploadURL"
                                                        :cropper-options="cropperOptions"
                                                        :output-options="outputOptions"
                                                        output-mime="image/jpeg"
                                                        :output-quality="outputQuality"
                                                        @completed="photoCompleted" />
                                    </div>
                                    <div id="picError" class="alert status"></div>
                                </div>
                                <div class="div-br"></div>
                                <div class="document-block">
                                    <div class="left">
                                        <h3>Passport photo</h3>
                                        <p>Please upload an image, in color, of your passport information page that contains photo and personal details in PDF format. The size of the photo must be less or equal to 1 megabyte (MB)</p>
                                        <p class="bt-24">Use a scanner or camera for taking a photo of the passport (not a copy of it)</p>
                                        <a class="app-btn-proceed" href="/#/req_passport">read more</a>
                                    </div>
                                    <div id="dropPassport" class="dropzone right">
                                        <object id="img6" class="pass-thumbnail" />
                                        <div id="passportError" class="alert status"></div>
                                    </div>
                       

                                </div>
                                <div class="div-br"></div>
                                <div class="document-block">
                                    <div class="left">
                                        <h3>Supporting documents</h3>
                                        <p>Upload here all relevant supporting documents for your Visa type. For details see the <a style="color: #5E9EEA;" href="/#/terms">Visa Terms and Conditions page</a>. All documents must be scanned in a single file not bigger that 5Mb in size.</p>
                                    </div>
                                    <div id="dropSupDoc" class="dropzone right">
                                        <object id="img9" class="pass-thumbnail" />
                                        <div id="affidavitError" class="alert status"></div>
                                    </div>

                                </div>

                                <div class="div-br"></div>

                                <div class="document-block top16">
                                    <div class="form-group row">
                                        <div class="col-12">
                                            <h5>Click Submit to Complete your application</h5>
                                            <div id="sbmButton" style="display:none" class="col-sm-12 submit-row">
                                                <button type="button" v-on:click="save()" class="btn-submit top16">Submit</button>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <label class="done">Registration</label>
                        <label class="done">Payment</label>
                        <label class="done" href="#">Visa Form</label>
                        <label class="active" href="#">Documents</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 app">
                    <div class="document top64">
                        <div class="document-block">
                            <div class="left">
                                <h3>Your photo</h3>
                                <p>Each applicant must submit a color photograph, without corners, with a full face;</p>
                                <p>The photo must have been taken within the last six months;</p>
                                <p class="bt-24">The photo must be in color, on a white background, without frames and retouching</p>
                                <a class="app-btn-proceed" href="/#/req_photo">read more</a>
                            </div>
                            <div id="dropPic" class="portrait">
                                <img id="img1" class="img-thumbnail" :src="userAvatar" />
                                <div class="dz-default dz-message">
                                    <button id="pick-avatar" class="dz-button" type="button">Click to upload photo</button>
                                </div>
                            </div>
                            <div>
                                <img v-if="userAvatar" :src="userAvatar">

                                <avatar-cropper trigger="#pick-avatar"
                                                :labels="cropLabels"
                                                :upload-url="uploadURL"
                                                :cropper-options="cropperOptions"
                                                :output-options="outputOptions"
                                                output-mime="image/jpeg"
                                                :output-quality="outputQuality"
                                                @completed="photoCompleted" />
                            </div>
                            <div id="picError" class="alert status"></div>
                        </div>
                        <div class="div-br"></div>
                        <div class="document-block">
                            <div class="left">
                                <h3>Passport photo</h3>
                                <p>Please upload an image, in color, of your passport information page that contains photo and personal details in PDF format. The size of the photo must be less or equal to 1 megabyte (MB)</p>
                                <p class="bt-24">Use a scanner or camera for taking a photo of the passport (not a copy of it)</p>
                                <a class="app-btn-proceed" href="/#/req_passport">read more</a>
                            </div>
                            <div id="dropPassport_s" class="dropzone right">
                                <object id="img6" class="pass-thumbnail" />
                                <div id="passportError" class="alert status"></div>
                            </div>

                        </div>
                        <div class="div-br"></div>
                        <div class="document-block">
                            <div class="left">
                                <h3>Affidavit letter</h3>
                                <p>Please attach one of the following letters:</p>
                                <ul>
                                    <li>For Visitors: Invitation letter from the host</li>
                                    <li>For Business: Invitation letter from the host or facilitator in Botswana</li>
                                    <li>For Employment: Letter of confirmation of employment/contract of employment or offer letter</li>
                                    <li>For Tourist: Confirmation of bookings at hotel/lodges</li>
                                </ul>
                            </div>
                            <div id="dropSupDoc_s" class="dropzone right">
                                <object id="img9" class="pass-thumbnail" />
                                <div id="affidavitError" class="alert status"></div>
                            </div>

                        </div>

                        <div class="div-br"></div>

                        <div class="document-block top16 bt32">
                            <div class="form-group row">
                                <div class="col-12">
                                    <h5>Click Submit to Complete your application</h5>
                                    <div id="sbmButton" style="display:none" class="col-sm-12 submit-row">
                                        <button type="button" v-on:click="save()" class="btn-submit top16">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/bird-app-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import AvatarCropper from "vue-avatar-cropper"
    import TopMenu from "./Menu";
    var photoUploaded = false;
    var passportUploaded = false;
    var supDocUploaded = false;

    export default {
        name: 'Images',
        components: {
            AvatarCropper,
            TopMenu
        },

        model: {},
        data: () => ({
            model: {},
            formForUpdate: false,
            result: {},
            userAvatar: undefined,
            cropLabels: { submit: "Submit", cancel: "Cancel" },
            cropperOptions: { aspectRatio: 7 / 9.38 },
            outputOptions: { width: 235, height: 315 },
            outputQuality: 0.5,
            formData: function () {
                return { appID: this.appNum }
            },
            windowWidth: window.innerWidth
        }),
        watch: {
            windowWidth(newWidth, oldWidth) {
                //console.log ("it changed to "+newWidth+" from " +oldWidth);
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        mounted() {

            this.windowWidth = window.innerWidth;
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })

            if (this.appNum != null) {
                this.goToTop();
                this.getImage();
                this.getPassport();
                this.getSupDoc();
            }
            Dropzone.autoDiscover = false;

            var apiip = this.$apiip;
            var appId = this.appNum;
            if (this.windowWidth > 1279) {
                //console.log(332);
                var dropPassport = new Dropzone("div#dropPassport", {

                    url: this.$apiip + "/api/v1/images/" + this.appNum + "/passport",
                    init: function () {
                        this.on("addedfile", function (file) {
                            $("#img6").remove();
                            $("#dropPassport .dz-image-preview").remove();
                        });
                    },
                    thumbnailWidth: 500,
                    thumbnailHeight: 500,
                    maxFilesize: 50, // 50 MB
                    timeout: 180000, // 3 min
                    dictDefaultMessage: 'Click to upload passport',
                    acceptedFiles: '.pdf'
                });
                var dropSupDoc = new Dropzone("div#dropSupDoc", {
                    url: this.$apiip + "/api/v1/images/" + this.appNum + "/supdoc",
                    init: function () {
                        this.on("addedfile", function (file) {
                            $("#img9").remove();
                            $("#dropSupDoc .dz-image-preview").remove();
                        });
                    },
                    thumbnailWidth: 500,
                    thumbnailHeight: 500,
                    maxFilesize: 50, // 50 MB
                    timeout: 180000, // 3 min
                    dictDefaultMessage: 'Click to upload affidavit letter',
                    acceptedFiles: '.pdf'
                });
            }
            else{
                //console.log(333);
                var dropPassportSmall = new Dropzone("div#dropPassport_s", {

                    url: this.$apiip + "/api/v1/images/" + this.appNum + "/passport",
                    init: function () {
                        this.on("addedfile", function (file) {
                            $("#img6").remove();
                            $("#dropPassport_s .dz-image-preview").remove();
                        });
                    },
                    thumbnailWidth: 500,
                    thumbnailHeight: 500,
                    maxFilesize: 50, // MB
                    dictDefaultMessage: 'Click to upload passport',
                    acceptedFiles: '.pdf'
                });
                var dropSupDocSmall = new Dropzone("div#dropSupDoc_s", {
                    url: this.$apiip + "/api/v1/images/" + this.appNum + "/supdoc",
                    init: function () {
                        this.on("addedfile", function (file) {
                            $("#img9").remove();
                            $("#dropSupDoc .dz-image-preview").remove();
                        });
                    },
                    thumbnailWidth: 500,
                    thumbnailHeight: 500,
                    maxFilesize: 50, // MB
                    dictDefaultMessage: 'Click to upload affidavit letter',
                    acceptedFiles: '.pdf'
                });
            }

            var picError = $('#picError')
            var passportError = $('#passportError')
            var affidavitError = $('#affidavitError')

            if (this.windowWidth > 1279) {
                dropPassport.on("complete", function (file, res) {

                    var res = jQuery.parseJSON(file.xhr.response);
                    if (res.Status === 1) {
                        passportUploaded = true;
                        if (photoUploaded && passportUploaded && supDocUploaded) {
                            $("#sbmButton").show();
                        }
                        passportError.text('Hooray! Your data is submitted!')
                            .removeClass('alert-danger')
                            .addClass('alert-success');

                        $.get(apiip + '/api/v1/images/' + appId + '/6/image', function (data) {

                            if (data != null && data.length > 100) {
                                //console.log("11");
                                var _src = "data:application/pdf;base64, " + data;
                                $("#dropPassport").html('<object id="img6" class="pass-thumbnail" />');
                                $("#img6").attr("data", _src);
                                $("#dropPassport").removeClass("dz-started");
                                $("#dropPassport").append('<div id="passportError" class="alert status"></div><div class="dz-default dz-message"><button class="dz-button" type="button">Drop files here to upload</button></div>');
                            }
                        });

                    } else {
                        passportError.text(res.ErrorText)
                            .removeClass('alert-success')
                            .addClass('alert-danger')
                    }
                });

                dropSupDoc.on("complete", function (file, res) {
                    var res = jQuery.parseJSON(file.xhr.response);
                    if (res.Status === 1) {
                        supDocUploaded = true;
                        if (photoUploaded && passportUploaded && supDocUploaded)
                            $("#sbmButton").show();
                    

                        affidavitError.text('Hooray! Your data is submitted!')
                            .removeClass('alert-danger')
                            .addClass('alert-success');

                        $.get(apiip + '/api/v1/images/' + appId + '/14/image', function (data) {

                            if (data != null && data.length > 100) {
                                var _src = "data:application/pdf;base64, " + data;
                                $("#dropSupDoc").html('<object id="img9" class="pass-thumbnail" />');
                                $("#img9").attr("data", _src);
                                $("#dropSupDoc").removeClass("dz-started");
                                $("#dropSupDoc").append('<div id="affidavitError" class="alert status"></div><div class="dz-default dz-message"><button class="dz-button" type="button">Drop files here to upload</button></div>');
                            }
                        });

                    } else {
                        affidavitError.text(res.ErrorText)
                            .removeClass('alert-success')
                            .addClass('alert-danger')
                    }
                });
            } else {
                dropPassportSmall.on("complete", function (file, res) {

                    var res = jQuery.parseJSON(file.xhr.response);
                    if (res.Status === 1) {
                        passportUploaded = true;
                        if (photoUploaded && passportUploaded && supDocUploaded) 
                            $("#sbmButton").show();
                        
                        passportError.text('Hooray! Your data is submitted!')
                            .removeClass('alert-danger')
                            .addClass('alert-success');

                        $.get(apiip + '/api/v1/images/' + appId + '/6/image', function (data) {

                            if (data != null && data.length > 100) {
                               // console.log("11");
                                var _src = "data:application/pdf;base64, " + data;
                                $("#dropPassport_s").html('<object id="img6" class="pass-thumbnail" />');
                                $("#img6").attr("data", _src);
                                $("#dropPassport_s").removeClass("dz-started");
                                $("#dropPassport_s").append('<div id="passportError" class="alert status"></div><div class="dz-default dz-message"><button class="dz-button" type="button">Drop files here to upload</button></div>');
                            }
                        });

                    } else {
                        passportError.text(res.ErrorText)
                            .removeClass('alert-success')
                            .addClass('alert-danger')
                    }
                });

                dropSupDocSmall.on("complete", function (file, res) {
                    var res = jQuery.parseJSON(file.xhr.response);
                    if (res.Status === 1) {
                        supDocUploaded = true;
                        if (photoUploaded && passportUploaded && supDocUploaded)
                            $("#sbmButton").show();
                    
                        affidavitError.text('Hooray! Your data is submitted!')
                            .removeClass('alert-danger')
                            .addClass('alert-success');

                        $.get(apiip + '/api/v1/images/' + appId + '/14/image', function (data) {

                            if (data != null && data.length > 100) {
                                var _src = "data:application/pdf;base64, " + data;
                                $("#dropSupDoc_s").html('<object id="img9" class="pass-thumbnail" />');
                                $("#img9").attr("data", _src);
                                $("#dropSupDoc_s").removeClass("dz-started");
                                $("#dropSupDoc_s").append('<div id="affidavitError" class="alert status"></div><div class="dz-default dz-message"><button class="dz-button" type="button">Drop files here to upload</button></div>');
                            }
                        });

                    } else {
                        affidavitError.text(res.ErrorText)
                            .removeClass('alert-success')
                            .addClass('alert-danger')
                    }
                });
            }
        },
        computed: {
            appNum: function () {
                return this.$cookie.get('eVisaAppID')
            },
            uploadURL: function () {
                return this.$apiip + "/api/v1/images/" + this.appNum + "/picture";
            },
            fileUploaded: function () {
                return this.passportUploaded && this.photoUploaded;
            }
        },
        methods: {
            onResize() {
                this.windowWidth = window.innerWidth
            },
            goToTop: function () {
                $("html, body").animate({ scrollTop: 0 }, "fast");
            },
            async getImage() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/images/' + this.appNum + '/1/image')
                    const data = await response.json()
                    $("#img1").hide();
                    if (data != null && data.length > 100) {
                        var _src = "data:image/png;base64, " + data;
                        $("#img1").attr("src", _src);
                        $("#img1").show();
                        photoUploaded = true;
                        if (photoUploaded && passportUploaded && supDocUploaded) {
                            $("#sbmButton").show();
                        }
                    }

                } catch (error) {
                    console.error(error)
                }
            },
            async getPassport() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/images/' + this.appNum + '/6/image')
                    const data = await response.json()
                    if (data != null && data.length > 100) {
                        var _src = "data:application/pdf;base64, " + data;
                        $("#img6").attr("data", _src);
                        passportUploaded = true;
                        if (photoUploaded && passportUploaded && supDocUploaded) {
                            $("#sbmButton").show();
                        }
                    }

                } catch (error) {
                    console.error(error)
                }
            },
            async getSupDoc() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/images/' + this.appNum + '/14/image')
                    const data = await response.json()
                    if (data != null && data.length > 100) {
                        var _src = "data:application/pdf;base64, " + data;
                        $("#img9").attr("data", _src);
                        supDocUploaded = true;
                        if (photoUploaded && passportUploaded && supDocUploaded) {
                            $("#sbmButton").show();
                        }
                    }

                } catch (error) {
                    console.error(error)
                }
            },
            async save() {
                try {
                    var response = await fetch(this.$apiip + '/api/v1/application/' + this.appNum + '/status', {
                        method: 'POST',
                        body: JSON.stringify(this.model),
                        headers: { 'Content-type': 'application/json; charset=UTF-8' },
                    })
                    var data = await response.json()

                    this.result = data
                    console.log(this.result);
                    if (this.result.Status == 1) {
                        this.$router.push('Final');
                    } else if (this.result.Status == -2) {
                        alert("Application is not paid");
                    }

                    
                } catch (error) {
                    console.error(error)
                }
            },

            OnImageSelected(event) {
                if (event === null)
                    return;
                var selectedFile = event.target.files[0];
                var reader = new FileReader();

                var imgtag = document.getElementById("img1");
                imgtag.title = selectedFile.name;

                reader.onload = function (event) {
                    imgtag.src = event.target.result;
                };
                reader.readAsDataURL(selectedFile);
            },

            photoCompleted(resp, form, xhr) {
                photoUploaded = true;
                if (photoUploaded && passportUploaded && supDocUploaded) {
                    $("#sbmButton").show();
                }
                this.userAvatar = resp.relative_url;
                this.getImage();
            }
        }
    }
</script>
